// src/features/dashboard/mocks/Manager/idleTime.mock.ts

import {
  IdleTimeKpiResponse,
  IdleTeamChartResponse,
  IdleBreakdownResponse,
  IdleTrendResponse,
  AssociateIdleDetail,
} from '../../types/Manager/idleTime.types';

// ====================================
// KPI Card
// ====================================

export const idleKpiMock: IdleTimeKpiResponse = {
  spanIdlePercentage: 8.5,
  previousSpanIdlePercentage: 0,
  spanIdleTrend: 0,

  averageIdleTime: '00:00:00',

  withinTarget: 0,
  exceedingTarget: 10,

  teamLeadCode: 'SG375852',
  teamLeadName: 'Umesh Laxman Tare',

  associates: 4,
  bestTeamIdlePercentage: 8.36,

  targetPercentage: 2,
  totalAssociates: 10,

  trendDirection: 'Same',
  bestTeamStatus: 'Above Target',
};

// ====================================
// Team Chart
// ====================================

export const idleTeamChartMock: IdleTeamChartResponse[] = [
  {
    teamLeadCode: 'SG376500',
    teamLeadName: 'Sumit Pathak',

    associateCount: 3,

    thisWeekIdle: 8.69,
    lastWeekIdle: 8.51,

    targetPercentage: 14,

    currentWeekLoggedHours: '20:55:03',
    currentWeekIdleHours: '01:46:14',

    previousWeekLoggedHours: '18:06:45',
    previousWeekIdleHours: '20:26:24',
  },
  {
    teamLeadCode: 'SG378273',
    teamLeadName: 'Shivakumar H',

    associateCount: 3,

    thisWeekIdle: 8.60,
    lastWeekIdle: 8.61,

    targetPercentage: 14,

    currentWeekLoggedHours: '20:17:45',
    currentWeekIdleHours: '03:17:15',

    previousWeekLoggedHours: '15:20:47',
    previousWeekIdleHours: '22:48:04',
  },
  {
    teamLeadCode: '610233',
    teamLeadName: 'Suparno Basu Sarbadhikary',

    associateCount: 1,

    thisWeekIdle: 8.50,
    lastWeekIdle: 8.41,

    targetPercentage: 14,

    currentWeekLoggedHours: '05:06:23',
    currentWeekIdleHours: '16:45:03',

    previousWeekLoggedHours: '12:40:14',
    previousWeekIdleHours: '15:11:24',
  },
  {
    teamLeadCode: 'SG377854',
    teamLeadName: 'Deepak Rohilla',

    associateCount: 3,

    thisWeekIdle: 8.21,
    lastWeekIdle: 8.32,

    targetPercentage: 14,

    currentWeekLoggedHours: '13:33:12',
    currentWeekIdleHours: '00:25:13',

    previousWeekLoggedHours: '06:36:21',
    previousWeekIdleHours: '20:28:20',
  },
];

// ====================================
// Breakdown
// ====================================

export const idleBreakdownMock: IdleBreakdownResponse[] = [
  {
    masterActivityCategoryId: 1,
    categoryName: 'Development',
    subCategoryName: 'Visual Studio Code',
    colorHex: '#22C55E',
    isProductive: true,
    isNonProductive: false,
    isNoImpact: false,
    associateCount: 10,
    activityCount: 31,
    totalDurationSeconds: 135032,
    totalMinutes: 2250.53,
    totalHours: 37.51,
    percentage: 42.24,
  },
  {
    masterActivityCategoryId: 2,
    categoryName: 'Communication',
    subCategoryName: 'Teams',
    colorHex: '#3B82F6',
    isProductive: true,
    isNonProductive: false,
    isNoImpact: false,
    associateCount: 10,
    activityCount: 20,
    totalDurationSeconds: 61500,
    totalMinutes: 1025,
    totalHours: 17.08,
    percentage: 19.24,
  },
  {
    masterActivityCategoryId: 3,
    categoryName: 'Entertainment',
    subCategoryName: 'YouTube',
    colorHex: '#F97316',
    isProductive: false,
    isNonProductive: true,
    isNoImpact: false,
    associateCount: 10,
    activityCount: 20,
    totalDurationSeconds: 67104,
    totalMinutes: 1118.4,
    totalHours: 18.64,
    percentage: 20.99,
  },
];

// ====================================
// Idle Trend
// ====================================


export const idleTrendMock: IdleTrendResponse[] = [
  {
    teamLeadCode: 'SG376500',
    teamLeadName: 'Sumit Pathak',

    loggedDate: '2026-06-01',
    totalLoggedHours: '02:54:11',
    totalActiveHours: '00:00:47',
    totalIdleHours: '02:53:24',
    totalTimeOnSystem: '00:00:47',
    totalTimeAwayFromSystem: '00:00:00',
    idlePercentage: 10.74,
    activePercentage: 89.26,
  },
  {
    teamLeadCode: 'SG378273',
    teamLeadName: 'Shivakumar H',

    loggedDate: '2026-06-01',
    totalLoggedHours: '02:33:41',
    totalActiveHours: '00:36:32',
    totalIdleHours: '01:57:09',
    totalTimeOnSystem: '00:36:32',
    totalTimeAwayFromSystem: '00:00:00',
    idlePercentage: 7.35,
    activePercentage: 92.65,
  },
  {
    teamLeadCode: '610233',
    teamLeadName: 'Suparno Basu Sarbadhikary',

    loggedDate: '2026-06-01',
    totalLoggedHours: '08:02:19',
    totalActiveHours: '06:59:39',
    totalIdleHours: '01:02:40',
    totalTimeOnSystem: '06:59:39',
    totalTimeAwayFromSystem: '00:00:00',
    idlePercentage: 12.99,
    activePercentage: 87.01,
  },
  {
    teamLeadCode: 'SG377854',
    teamLeadName: 'Deepak Rohilla',

    loggedDate: '2026-06-01',
    totalLoggedHours: '02:34:24',
    totalActiveHours: '00:48:27',
    totalIdleHours: '01:45:57',
    totalTimeOnSystem: '00:48:27',
    totalTimeAwayFromSystem: '00:00:00',
    idlePercentage: 6.65,
    activePercentage: 93.35,
  },

  {
    teamLeadCode: 'SG376500',
    teamLeadName: 'Sumit Pathak',

    loggedDate: '2026-06-02',
    totalLoggedHours: '23:58:53',
    totalActiveHours: '21:47:01',
    totalIdleHours: '02:11:52',
    totalTimeOnSystem: '21:47:01',
    totalTimeAwayFromSystem: '00:00:00',
    idlePercentage: 9.16,
    activePercentage: 90.84,
  },
  {
    teamLeadCode: 'SG378273',
    teamLeadName: 'Shivakumar H',

    loggedDate: '2026-06-02',
    totalLoggedHours: '06:16:46',
    totalActiveHours: '04:24:31',
    totalIdleHours: '01:52:15',
    totalTimeOnSystem: '04:24:31',
    totalTimeAwayFromSystem: '00:00:00',
    idlePercentage: 6.18,
    activePercentage: 93.82,
  },
  {
    teamLeadCode: '610233',
    teamLeadName: 'Suparno Basu Sarbadhikary',

    loggedDate: '2026-06-02',
    totalLoggedHours: '08:40:32',
    totalActiveHours: '07:39:19',
    totalIdleHours: '01:01:13',
    totalTimeOnSystem: '07:39:19',
    totalTimeAwayFromSystem: '00:00:00',
    idlePercentage: 11.76,
    activePercentage: 88.24,
  },
  {
    teamLeadCode: 'SG377854',
    teamLeadName: 'Deepak Rohilla',

    loggedDate: '2026-06-02',
    totalLoggedHours: '03:13:40',
    totalActiveHours: '00:49:33',
    totalIdleHours: '02:24:07',
    totalTimeOnSystem: '00:49:33',
    totalTimeAwayFromSystem: '00:00:00',
    idlePercentage: 8.82,
    activePercentage: 91.18,
  },
];

// ====================================
// Associate Idle Details
// ====================================

export const associateIdleDetailsMock: AssociateIdleDetail[] = [
  {
    employeeCode: 'SG386677',
    fullName: 'Jyothi M.',
    department: 'Healthcare EAM',
    loggedDate: '2026-06-11',
    shiftName: 'General',
    attendanceStatus: 'Present',
    loggedHours: '07:58:10',
    activeHours: '06:49:02',
    idleHours: '01:09:08',
    timeOnSystem: '06:49:02',
    timeAwayFromSystem: '00:00:00',
    idlePercentage: 14.43,
    idleStatus: 'Medium',
    status: 'Warning',
  },
  {
    employeeCode: 'SG376500',
    fullName: 'Sumit Pathak',
    department: 'Healthcare EAM',
    loggedDate: '2026-06-30',
    shiftName: 'General',
    attendanceStatus: 'Present',
    loggedHours: '08:17:21',
    activeHours: '07:07:48',
    idleHours: '01:09:33',
    timeOnSystem: '07:07:48',
    timeAwayFromSystem: '00:00:00',
    idlePercentage: 13.99,
    idleStatus: 'Medium',
    status: 'Warning',
  },
  {
    employeeCode: 'SG381157',
    fullName: 'Ajay Hrishikesh Sabat',
    department: 'Healthcare EAM',
    loggedDate: '2026-06-15',
    shiftName: 'General',
    attendanceStatus: 'Present',
    loggedHours: '07:50:51',
    activeHours: '06:46:21',
    idleHours: '01:04:30',
    timeOnSystem: '06:46:21',
    timeAwayFromSystem: '00:00:00',
    idlePercentage: 13.76,
    idleStatus: 'Medium',
    status: 'Warning',
  },
];